import React from 'react';
import type { FinancialSeries } from '@app-types/performanceTrends';
import './ChartLegend.less';

export interface ChartLegendProps {
  series: FinancialSeries[];
  nodeId?: string;
}

/**
 * DOM legend rendered below grouped financial charts (see PT02).
 * Kept out of ECharts so spacing matches the Figma legend row exactly.
 */
const ChartLegend: React.FC<ChartLegendProps> = ({ series, nodeId }) => (
  <ul className="trends-chart-legend" data-node-id={nodeId}>
    {series.map((s) => (
      <li key={s.key} className="trends-chart-legend__item">
        <span
          className="trends-chart-legend__swatch"
          style={{ backgroundColor: s.color }}
          aria-hidden="true"
        />
        <span className="trends-chart-legend__label">{s.label}</span>
      </li>
    ))}
  </ul>
);

export default ChartLegend;
